import { createAction, props } from '@ngrx/store';
import { OrderForm } from '@ordersnproducts/modules/multiple-order-online/redux/reducers/orders-forms.reducer';
import { FormattedAddress } from '@ordersnproducts/modules/shared/models/FormattedAddress.interface';
import { BusinessDayType } from '@ordersnproducts/utils/utils';

export const addForm = createAction(
  '[MULTIPLE ORDERS] [ORDERS FORMS] Add Form',
  props<{ timestamp: number; defaultValues: {} }>(),
);

export const deleteForm = createAction('[MULTIPLE ORDERS] [ORDERS FORMS] Delete Form', props<{ formId: string }>());

export const updateForm = createAction(
  '[MULTIPLE ORDERS] [ORDERS FORMS] Update Form',
  props<{ formId: string; formControlName: string; formControlvalue: any; formIsValid: boolean }>(),
);

export const closeUntouchedForms = createAction('[MULTIPLE ORDERS] [ORDERS FORMS] Close untouched forms');

export const selectForm = createAction('[MULTIPLE ORDERS] [ORDERS FORMS] Select Form', props<{ formId: string }>());

export const unselectForm = createAction('[MULTIPLE ORDERS] [ORDERS FORMS] Unselect Form');

export const duplicateSelectedForm = createAction(
  '[MULTIPLE ORDERS] [ORDERS FORMS] Duplicate Selected Form',
  props<{ dates: number[]; selectedForm: OrderForm; expandCard: boolean }>(),
);

export const updateTouchedForm = createAction(
  '[MULTIPLE ORDERS] [ORDERS FORMS] Touched form for show',
  props<{ formId: string; isExpanded: boolean }>(),
);

export const termsAndConditionsCheckbox = createAction(
  '[MULTIPLE ORDERS] [ORDERS FORMS] Terms and conditions checkbox changed',
  props<{ formId: string; isChecked: boolean }>(),
);

export const setBigo = createAction(
  '[MULTIPLE ORDERS] [ORDERS FORMS] Set BIGO',
  props<{ formId: string; isBIGO: boolean }>(),
);
export const resetBigo = createAction('[MULTIPLE ORDERS] [ORDERS FORMS] Reset BIGO', props<{ formId: string }>());

export const setBusinessDayType = createAction(
  '[MULTIPLE ORDERS] [ORDERS FORMS] Set BusinessDay Type',
  props<{ formId: string; businessDayType: BusinessDayType }>(),
);
export const resetOrderForm = createAction('[MULTIPLE ORDERS] [ORDERS FORMS] Reset Forms');

export const setLiabilityCheck = createAction(
  '[MULTIPLE ORDERS] [ORDERS FORMS] accept liability check',
  props<{ formId: string; checked: boolean }>(),
);

export const prefillOrderForm = createAction(
  '[MULTIPLE ORDERS] [ORDERS FORMS] Prefill Order Form',
  props<{ timestamp: number; defaultValues: {} }>(),
);

export const updateLimitOfOrderForm = createAction(
  '[MULTIPLE ORDERS] [ORDERS FORMS] Update Limit of Order Form',
  props<{ maximumNumberOfOrders: number }>(),
);

export const setSelectedPodAddress = createAction(
  '[MULTIPLE ORDERS] [ORDERS FORMS] Set Selected Pod Address',
  props<{ formId: string; selectedPodAddress: FormattedAddress }>(),
);

export const OrdersFormsActions = {
  addForm,
  deleteForm,
  updateForm,
  closeUntouchedForms,
  selectForm,
  unselectForm,
  duplicateSelectedForm,
  updateTouchedForm,
  resetOrderForm,
  termsAndConditionsCheckbox,
  setBigo,
  resetBigo,
  setBusinessDayType,
  setLiabilityCheck,
  prefillOrderForm,
  updateLimitOfOrderForm,
  setSelectedPodAddress,
};

export default OrdersFormsActions;
